<template>
    <div class="operation" v-if="search.input">
      <form class="clearfix" @submit.prevent="search.event">
        <div class="width100">
          <div class="float-left" v-for="item in search.input" v-if="item.show?item.show():true">
            <span v-if="item.label">{{item.label}}</span>
            <v-select v-if="item.type=='sort'" v-model="item.value" :placeholder="item.placeholder" :options="item.options" @sel="item.event($event)" :width="item.width"></v-select>
            <date-picker v-if="item.type=='date'" v-model="item.values" width="220" :place="item.placeholder" range clearable></date-picker>
            <date-picker v-if="item.type=='date_picker'" v-model="item.value" width="220" :place="item.placeholder" clearable></date-picker>
            <dt-picker v-if="item.type=='start_time'" v-model="item.value" :place="item.placeholder" string></dt-picker>
            <dt-picker v-if="item.type=='end_time'" v-model="item.value" :place="item.placeholder" string></dt-picker>
            <input class="input" v-if="item.type=='input'" type="text" :placeholder="item.placeholder" v-model.trim="item.value">
            <input class="input" v-if="item.type=='input_abutton'" type="text" :placeholder="item.placeholder" v-model="item.value">
            <a class="abutton" v-if="item.type=='input_abutton'" @click="item.event">选择剧名</a>
            <v-select v-if="item.type=='select'" v-model="item.value" :placeholder="item.placeholder" :options="item.options" @sel="item.event?item.event($event):null" :width="item.width"></v-select>
            <template v-if="item.type=='url'&&item.selstyle=='select'">
              <property-select :selstyle="item.selstyle" :url="item.url" v-model="item.value" @property="item.options=$event.map(v=>{return {name:v.name||v.channel,value:v.channel||v.code||v.id} })" :placeholder="item.placeholder" :multi="item.value instanceof Array" :opt="item.opt" :delay="item.delay"></property-select>
            </template>
          </div>
          <div class="float-left" v-if="search.input.filter(v=>v.selstyle=='checkbox').length==0">
            <button type="submit" :title="$t('components.ooperatepanel.search')" class="iconfont">&#xe620;</button>
            <button type="button" :title="$t('components.ooperatepanel.empty')" class="iconfont" @click="clear">&#xe640;</button>
          </div>
        </div>

        <template v-for="item in search.input">
          <div class="width100 checkstyle" v-if="item.type=='url'&&item.selstyle!=='select'">
            <span>{{item.placeholder}}</span>
            <div style="margin-left: 120px;margin-right: 60px;position: relative">
            <property-select :selstyle="item.selstyle" :url="item.url" v-model="item.value" @property="item.options=$event.map(v=>{return {name:v.name||v.channel,value:v.channel||v.code||v.id} })" :opt="item.opt"></property-select>
            </div>
          </div>
        </template>

        <div class="width100 tags" v-if="search.input.filter(v=>v.selstyle=='checkbox').length>0">
          <span>{{$t('components.ooperatepanel.filter_condition')}}</span>
          <div style="margin-left: 120px;margin-right: 60px;position: relative">
          <template v-for="item in search.input" v-if="item.value && item.type!=='start_time' && item.type!=='end_time'">
          <span v-if="typeof item.value==='string'" @click="item.value=''">{{item.value}}</span>
          <span v-if="item.value instanceof Array && item.options.filter(v=>v.value==i)[0]" v-for="i,index in item.value" @click="item.value.splice(index,1)">{{item.options.filter(v=>v.value==i)[0].name}}</span>
          <span v-if="typeof item.value==='number'" @click="item.value=''">{{item.options.filter(v=>v.value==item.value)[0].name}}</span>
          </template>
          </div>
          <button type="submit">{{$t('components.ooperatepanel.search')}}</button>
          <button  type="button" @click="clear">{{$t('components.ooperatepanel.empty')}}</button>
        </div>

        <div class="float-right" v-if="buttons.length">
            <button type="button" class="button" @click="button.event" v-for="button in buttons">{{button.name}}</button>
        </div>
      </form>
      <div class="radio" v-if="search.order">
        <template v-for="(item,index) in search.order.options">
          <input type="radio" :id="randomId + index" :value="item.value" v-model="search.order.value">
          <label :for="randomId + index">{{item.name}}</label>
        </template>
      </div>
    </div>
</template>

<script>
  import {merge} from '../server/utils.js'
  export default {
    name: "OperatePanel",
    props:{
      search:{
        type:Object,
        default:function () {}
      },
      buttons:{
        type:Array,
        default:function () {
           return []
        }
      }
    },
    data () {
      return {
        clean:{},
        randomId:'radio-' + Math.random()
      }
    },
    methods:{
      clear () {
        this.search.input.forEach((val)=>{
          this.clean.input.forEach(v=>{
            if(v.key==val.key){
              if(v.values) {
                merge(val.values,v.values);
              }else{
                val.value = v.value
              }
            }
          })
        })
        this.search.event()
      },
      formatD(type,val){
        if(val){
          var month = new Date(val).getMonth()+1 < 10 ? '0'+(new Date(val).getMonth()+1) : new Date(val).getMonth()+1
          var day = new Date(val).getDate()<10 ? '0'+ new Date(val).getDate() : new Date(val).getDate()
          var date = new Date(val).getFullYear()+'-'+month+'-'+ day
          if(type=='date'){
            return date
          }else if(type=='utc'){
            return date + 'T00:00:00+08:00'
          }else{
            var time = '00:00:00'
            if(val.getHours()>0){
              time = val.getHours() +':'+ val.getMinutes() +':'+ val.getSeconds()
            }
            return date +' '+ time
          }
        }else{
          return ''
        }
      },
      start(type,val){
          var parent = this.$parent;
          if(!parent.opts) {
            parent = parent.$parent;
          }
          if(parent.opts) {
            parent.opts.start_time = this.formatD(type, val)
          }
      },
      end(type,val){
        var parent = this.$parent;
        if(!parent.opts) {
          parent = parent.$parent;
        }
        if(parent.opts) {
          parent.opts.end_time = this.formatD(type, val)
        }
      }
    },
    mounted(){
      this.clean = JSON.parse(JSON.stringify(this.search))
    }
  }
</script>

<style lang="less" scoped>
  @import '@/assets/css/varible.less';
  .operation{
    margin:15px 21px;
    .input{width:174px}
  }
  button.iconfont{
    color:@blue;
    cursor: pointer;
    margin-right: 15px;
    line-height: 30px;
    font-size: 24px;
  }
  .float-left{
    margin-right: 20px;
    margin-bottom: 4px;
  }
  .input{
      width: 174px!important;
      height: 30px;
      line-height: 30px;
      padding-left: 4px;
      border:1px solid @border-bg;
    }
  .button{
    margin:0 5px;
    .button()
  }
  .abutton{
    color: #0072c5;
  }
  .radio>label{display: inline-block; min-width: 176px; margin-right: 15px; margin-top: 10px; }
  .width100{width: 100%; float: left; margin-bottom: 10px; }
  .width100 span{width: 120px; float: left; cursor: pointer; }
  .tags button{background: @blue;color: #fff;padding: .3em 1em;font-size: 12px;text-align: center;border-radius: 3px;float: left;margin:0 5px 5px 0;}
  .tags button[type="button"]{background:none;color:@blue}
  .checkstyle span:hover{color: @blue}
  // .checkstyle{overflow: hidden;transition: all 1s;transition-delay: .5s;max-height:30px;}
  // .checkstyle:hover{max-height: 120px; }
  .tags>div>span{background: #fff;padding: .3em 1.2em .3em .5em;position: relative;float: left;margin:0 5px 5px 0;border:1px solid #ccc;width:auto;font-size: 12px;}
  .tags>div>span:after{content: "×";position: absolute;right:5px;top:0;color: #000;cursor: pointer;font-size: 10px;}
  .tags>div>span:hover{border-color: orange;cursor: pointer;}
</style>
